<template>
  <div class="period-control">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="period-element"
      :class="{ active: item.months === modelValue }"
      @click="$emit('update:modelValue', item.months)"
    >
      {{ item.text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PeriodControl',

  props: {
    modelValue: {
      type: Number,
      required: true,
    },
  },

  computed: {
    items() {
      return [
        { months: 1, text: this.__('website.tariffs.1_mo') },
        { months: 3, text: this.__('website.tariffs.3_mo') },
        { months: 6, text: this.__('website.tariffs.6_mo') },
        { months: 12, text: this.__('website.tariffs.12_mo') },
      ];
    },
  },
};
</script>

<style lang="sass" scoped>
.period-control
  user-select: none
  background: #232838
  border-radius: 100px
  display: flex
.period-element
  width: 106px
  border-radius: 100px
  text-align: center
  color: #9DA3AE
  font-size: 14px
  line-height: 16px
  padding: 12px 0
  cursor: pointer
  transition: background .25s
  &.active
    background: #415E74
    color: #fff

@media screen and (max-width: 480px)
  .period-element
    width: auto
    padding: 12px 9px
</style>